import { useSyncExternalStore } from 'react';

/** Live `matchMedia` result (false where there is no window, e.g. tests and SSR). */
export const useMediaQuery = (query: string): boolean =>
  useSyncExternalStore(
    (onChange) => {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => undefined;
      const m = window.matchMedia(query);
      m.addEventListener('change', onChange);
      return () => m.removeEventListener('change', onChange);
    },
    () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches,
    () => false,
  );

/** Phones: the register and its filters switch to a list and a sheet below Tailwind's `sm` (640 px). */
export const PHONE = '(max-width: 639px)';
